import { useEffect } from "react";
import styled from "styled-components";
import bg from "@/assets/背景.jpg";
import Introduce from "./pages/Introduce";
import AnniversaryServerExclusive from "./pages/AnniversaryServerExclusive";
import NewServerActivity from "./pages/NewServerActivity/index";
import NewServerGuide from "./pages/NewServerGuide";
import Footer from "./pages/Footer";

const UI_WIDTH = 1920;
function App() {
  const adjustContainer = () => {
    let width = document.body.clientWidth;
    const zoom = width / UI_WIDTH;
    const fontSize = 16 * zoom;
    (document.querySelector("html") as any).style.fontSize = `${fontSize}px`;
  };

  const open = () => {
    window.open("https://jx.xoyo.com/index1/");
  };

  useEffect(() => {
    adjustContainer();
    window.addEventListener("orientationchange", adjustContainer);
    window.addEventListener("resize", adjustContainer);
  }, []);

  return (
    <Container>
      <img src={bg} alt="" className="kv" />
      <img
        src={require("@/assets/logo.png")}
        alt=""
        className="logo"
        onClick={open}
      />
      <div className="content">
        <Introduce />
        <AnniversaryServerExclusive />
        <NewServerActivity />
        <NewServerGuide />
        <Footer />
      </div>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  .kv {
    width: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }
  .content {
    position: absolute;
    top: 53rem;
    width: 64%;
    padding: 0 18%;
  }
  .logo {
    width: 15rem;
    position: absolute;
    top: 1rem;
    left: 22rem;
    cursor: pointer;
  }
`;

export default App;
